import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useQuery } from '@tanstack/react-query';

export const GET_FOLDER_QUERY_KEY = 'folders.getFolder';

export const useGetFolder = ({ folderId }: { folderId?: string }) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();
  const { data, isLoading, error } = useQuery({
    queryKey: [GET_FOLDER_QUERY_KEY, { folderId, tenantId }],
    queryFn: () => api.folders.getFolder(tenantId, folderId ?? ''),
    enabled: !!folderId && !!tenantId,
  });

  return {
    folder: data?.data.folder,
    isLoading,
    error,
  };
};
